import { gql } from "@apollo/client";
import { BAG_TAG_FIELDS, BagType } from "../types/BagTagType";

// 重新导出BagType，这样其他文件可以从这里导入
export type { BagType };

export const GET_BAG_LISTING = gql`
    query BagListing($filters: BagFiltersTypeInput,
                     $pageRequest: PageRequestTypeInput) {
        getBagListing(filters: $filters,
                      pageRequest: $pageRequest) {
            content{
                ...BagTagFields
            }
            page
            size
            totalElements
            totalPages
            hasNext
            hasPrevious
        }
    }
    ${BAG_TAG_FIELDS}
`;

export interface BagFiltersType {
    warehouseId: string;
    bagNumber?: string;
    externalBagNumber?: string;
    bagType?: number;
    sortingCode?: string;
    status?: number;
    createdAt?: {
        start?: string;
        end?: string;
    };
    bagTaskId?: number;
    bagTaskNumber?: string;
    carrierCode?: number;
    sourceType?: number;  // 0-手动创建，1-组包创建，2-交叉带创建，3-批次创建
    batchNumber?: string;  // 批次号（部分匹配）
    mergedToBagNumber?: string;  // 合包归属包牌号（完整匹配；命中保留包牌 self-pointing + 所有合入它的源包牌）
    // 分拣码分段筛选（后端拼接为完整前缀，按 bag.sorting_code LIKE 'X%'）
    sortingCodeSegment1?: string;
    sortingCodeSegment2?: string;
    sortingCodeSegment3?: string;
    sortingCodeSegment4?: string;
    sortingRuleSecond?: string;  // 预分拣码（部分匹配）
    // PPMOD 新增：外部业务类型 0=普通 / 1=PP；容器类型 id
    externalBusinessType?: number;
    bagContainerId?: number;
}

export interface PageRequestType {
    page: number;
    size: number;
    sortBy: string;
    sortDirection: string;
}

export interface BagListingResponseType {
    content: BagType[];
    page: number;
    size: number;
    totalElements: number;
    totalPages: number;
    hasNext: boolean;
    hasPrevious: boolean;
}

export interface BagListResponse {
    getBagListing: BagListingResponseType;
}

export interface GetBagListingInput {
    filters: BagFiltersType;
    pageRequest?: PageRequestType;
}
